const security_type_list = [
  {
    id: "security_disable",
    value: "Disable",
    label: "sec_off",
    config: "None",
  },
  {
    id: "security_wpa2",
    value: "WPA2-PSK",
    label: "sec_wpa2",
    config: "WPA2-Personal",
  },
  {
    id: "security_auto",
    value: "AUTO-PSK",
    label: "sec_wpas",
    config: "WPA-Personal+WPA2-Personal",
  },
  {
    id: "security_wpa3",
    value: "WPA3-PSK",
    label: "sec_wpa3",
    config: "WPA3-Personal",
  },
];

const status_map = [
  { value: true, config: "1" },
  { value: false, config: "2" },
];

export const guest = {
  status: status_map,
  security_type: security_type_list,
};

export default guest;
